import api from './api';

class SettingSlideService {
  getDataSlide(dataForm) {
    return api.post('/merchant/slide-setting', dataForm);
  }

  addOrUpdateSlide(dataForm) {
    return api.post('/merchant/slide-setting/create-or-update', dataForm, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    });
  }

  updateSlidesOrder(dataForm) {
    return api.post("/merchant/slide-setting/update-slides-order", dataForm);
  }

  // MBR133: background of the member app's sign-in page.
  getLoginBackground() {
    return api.post("/merchant/slide-setting/login-background");
  }

  saveLoginBackground(dataForm) {
    return api.post("/merchant/slide-setting/login-background/save", dataForm, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    });
  }

  // SF307: header picture of the physical-branch outlet list.
  getOutletListHeader() {
    return api.post("/merchant/slide-setting/outlet-list-header");
  }

  saveOutletListHeader(dataForm) {
    return api.post("/merchant/slide-setting/outlet-list-header/save", dataForm, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    });
  }
}

export default new SettingSlideService();
